export default {
  ecopledges: null,
  ecopledge: null,
  ecopledgeToCreate: null,
  ecopledgeDeletionPending: [],
  ecopledgeCreationPending: false,
  ecopledgeUpdatePending: false,
  ecopledgeLoading: false
}
